export enum LocalStorageKey {
  TOKEN = 'token',
  IRIS_TOKEN = 'irisToken',
}
